import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KanbanSquare, Plus, Upload } from 'lucide-react';
import PipelineKanban from '../components/pipeline/PipelineKanban';
import NewLeadModal from '../components/leads/NewLeadModal';
import CsvImportModal from '../components/leads/CsvImportModal';
import { Button } from '../components/ui/button';

const Pipeline = () => {
  const navigate = useNavigate();
  const [showNewLeadModal, setShowNewLeadModal] = useState(false);
  const [showCsvImportModal, setShowCsvImportModal] = useState(false);
  const [editingLead, setEditingLead] = useState(null);

  return (
    <div className="space-y-6 h-full flex flex-col">
      {/* Header with Tab Toggle */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <KanbanSquare className="h-8 w-8 text-primary" />
          <div>
            <h1 className="text-3xl font-bold text-secondary">Pipeline</h1>
            <p className="text-muted-foreground">Kanban view of your sales pipeline</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {/* Import Leads Button — basic 9-column prospect import. */}
          <Button
            onClick={() => setShowCsvImportModal(true)}
            variant="outline"
            className="shadow-sm"
            data-testid="pipeline-import-leads-btn"
          >
            <Upload className="h-4 w-4 mr-2" />
            Import Leads
          </Button>

          {/* New Lead Button */}
          <Button
            onClick={() => setShowNewLeadModal(true)}
            className="text-white shadow-sm"
            style={{ backgroundColor: 'var(--cb-orange)' }}
          >
            <Plus className="h-4 w-4 mr-2" />
            New Lead
          </Button>

          {/* Tab Toggle */}
          <div className="flex bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
            <button
              className="px-4 py-2 text-sm font-medium transition-colors"
              style={{
                backgroundColor: 'var(--cb-orange)',
                color: 'white'
              }}
            >
              Pipeline
            </button>
            <button
              onClick={() => navigate('/leads')}
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
            >
              List View
            </button>
          </div>
        </div>
      </div>

      {/* Kanban Board */}
      <div className="flex-1 overflow-hidden">
        <PipelineKanban onEditLead={setEditingLead} />
      </div>

      {/* CSV Import Modal — leads mode (prospects only) */}
      <CsvImportModal
        isOpen={showCsvImportModal}
        onClose={() => setShowCsvImportModal(false)}
        mode="leads"
      />

      {/* New Lead Modal - Create */}
      <NewLeadModal
        isOpen={showNewLeadModal}
        onClose={() => setShowNewLeadModal(false)}
        mode="create"
      />

      {/* Edit Lead Modal - Shared with list view */}
      <NewLeadModal
        isOpen={!!editingLead}
        onClose={() => setEditingLead(null)}
        mode="edit"
        lead={editingLead}
      />
    </div>
  );
};

export default Pipeline;
